import { useIntl } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { getRarityColor } from 'lib/colors';
import { scarcityMessages } from 'lib/scarcity';

const Root = styled.span`
  color: var(--text-color);
  font-weight: var(--t-bold);
`;

type Props = { scarcity: Rarity };

export const ScarcityLabel = ({ scarcity }: Props) => {
  const { formatMessage } = useIntl();

  const label = formatMessage(scarcityMessages[scarcity]);

  return (
    <Root style={{ '--text-color': getRarityColor(scarcity) } as CSSProperties}>
      {label}
    </Root>
  );
};
